/**
 * This file exists to minimise the size of the final file due to how GSAP handles it's exports, and reduce the change
 * of accidentally importing from all.js. If you import from 'gsap/all', you get a massive file with lots of unused
 * code.
 */

import TweenLite from 'gsap/TweenLite';
import CSSPlugin from 'gsap/CSSPlugin';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import {Linear, Power0, Power1, Power2, Power3, Power4} from 'gsap/EasePack';

export {
    TweenLite,
    CSSPlugin,
    ScrollToPlugin,
    Linear,
    Power0,
    Power1,
    Power2,
    Power3,
    Power4
}


// WEBPACK FOOTER //
// ./site/templates/resources/src/js/tools/gsap.js